// Shared controlled country list for staff contact editing (international model).
// Values are display names to remain consistent with existing free-text country data.
// Sorted A–Z by display name; "Other" is pinned last.
export const COUNTRIES = [
  "Argentina", "Australia", "Austria",
  "Bahrain", "Bangladesh", "Belgium", "Bolivia", "Brazil", "Brunei",
  "Cambodia", "Canada", "Chile", "China", "Colombia", "Costa Rica", "Czech Republic",
  "Denmark", "Dominican Republic",
  "Ecuador", "Egypt",
  "Finland", "France",
  "Georgia", "Germany", "Ghana", "Greece", "Guatemala",
  "Hong Kong", "Hungary",
  "Iceland", "India", "Indonesia", "Ireland", "Israel", "Italy",
  "Japan",
  "Kazakhstan", "Kenya", "Kuwait",
  "Laos",
  "Malaysia", "Mexico", "Morocco", "Myanmar",
  "Nepal", "Netherlands", "New Zealand", "Nigeria", "Norway",
  "Oman",
  "Pakistan", "Panama", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico",
  "Qatar",
  "Russia",
  "Saudi Arabia", "Singapore", "South Africa", "South Korea", "Spain", "Sri Lanka", "Sweden", "Switzerland",
  "Taiwan", "Thailand", "Turkey",
  "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay",
  "Vietnam",
  "Other",
];
